module.exports = __webpack_public_path__ + "static/media/ENS_Logo-blue.a89afcb8.png";